module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/shipping/shipping-box-db619411a4f76a50820c461b55591b82.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/shipping/shipping-box.svg
// module id = EB0Y
// module chunks = 24